import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { track } from "@/lib/api";

export const SituationSelector = ({ pathways = [], headingLevel = "h2", testId = "situation-selector" }) => {
  const Heading = headingLevel;
  return (
    <section className="bg-[#1E2326] text-cream relative overflow-hidden" aria-labelledby={`${testId}-heading`} data-testid={testId}>
      <div className="container-site py-16 md:py-24 grid gap-10 lg:grid-cols-[0.9fr_1.6fr]">
        <div>
          <p className="eyebrow !text-sage mb-3">Find your way</p>
          <Heading id={`${testId}-heading`} className="text-3xl sm:text-4xl !text-cream">What brings you here today?</Heading>
          <p className="mt-5 text-cream/80 max-w-md">Choose the option closest to how things feel right now. You'll get guidance, next steps and trusted UK support, with no sign-up needed.</p>
        </div>
        <ul className="grid gap-3 sm:grid-cols-2">
          {pathways.map((p) => (
            <li key={p.slug}>
              <Link to={`/find-your-way/${p.slug}`} onClick={() => track("pathway", p.slug)}
                className="group flex items-center justify-between gap-4 h-full rounded-2xl border border-cream/15 bg-white/[0.04] px-5 py-5 min-h-[76px] text-[1.02rem] font-medium text-cream transition-colors duration-200 hover:bg-cream hover:text-ink"
                data-testid={`situation-option-${p.slug}`}>
                <span>{p.label}</span>
                <ArrowRight className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1" aria-hidden="true" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
